import React from "react";
import { CircleCheck } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const features = ["Kostenlose Besichtigung & Festpreisangebot", "Fachgerechte Entsorgung & Recycling", "Besenreine Übergabe aller Räumlichkeiten", "Absolute Diskretion & Zuverlässigkeit"];
export default function ServicesGridClearance() {
  return;
}